<template>
  <v-autocomplete dense v-model="bulkContainerId" :class="{'text-body-2':!outlined}" :outlined="outlined" :label="label"
                  no-data-text="No bulk containers available"
                  :items="bulkContainers" item-text="name" item-value="id" :rules="[mandatory]"
                  :hint="contents" persistent-hint
                  @change="$emit('input',bulkContainerId);$emit('change',bulkContainerId)">
    <template v-slot:item="{item}">
      <v-list-item-content>
        <v-list-item-title>{{item.name}}</v-list-item-title>
        <v-list-item-subtitle class="text-caption" :class="{'green--text':highlight && highlight(item)}" v-if="hint">
          {{alcoholName(item)}}
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>

</template>

<script>
export default {
  name: 'BulkContainerSelect',
  props: {
    value: {type:String, required:true},
    bulkContainers: {type:Array, required:true},
    required: {type:Boolean, required:false, default:true},
    outlined: {type:Boolean, required:false, default:false},
    label: {type:String, required:false},
    highlight: {type:Function,required:false},
    hint: {type:Boolean, required:false, default:true}
  },
  data() {
    return {
      bulkContainerId: this.value,
      mandatory: v => !this.required || !!v || 'Required',
    }
  },
  computed: {
    contents() {
      if (!this.hint)
        return;
      const bulkContainer = this.bulkContainers.find(bulkContainer => bulkContainer.id === this.bulkContainerId);
      if (bulkContainer)
        return this.alcoholName(bulkContainer);
    }
  },
  watch: {
    value() {
      this.bulkContainerId = this.value;
    }
  },
  methods: {
    alcoholName(bulkContainer) {
      if (bulkContainer.contents) {
        let amount = '(empty)';
        if (bulkContainer.contents.alcoholType && bulkContainer.contents.volume) {
          const spirits = bulkContainer.contents.alcoholType === 'Spirit';
          amount = `${this.$number(bulkContainer.contents.volume, 3)} ${spirits?'LAA':'litres'} ${bulkContainer.contents.alcoholName}`;
        }
        return amount;
      }
    }
  }
}
</script>